















import { Component, Vue } from "vue-property-decorator"

@Component
export default class BusinessInstructions extends Vue {
  instructions = ""
  isMounted = false
  async beforeMount() {
    await this.$store
      .dispatch("Document/fetch", "quescreen-business-user-instructions")
      .then((response) => {
        this.instructions = response.data.data
        const matches: [] = response.data.data.match(
          /<img.+src=(?:"|')(.+?)(?:"|')(?:.+?)>/
        ) || []
        for (let i = 0; i < matches.length; i++) {
          if (i % 2 !== 0) {
            this.instructions = this.instructions.replaceAll(
              matches[i],
              process.env.VUE_APP_API_PREFIX + matches[i]
            )
          }
        }
        this.isMounted = true
      })
  }
}
